import { Component } from 'react';

class Section extends Component {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static defaultProps: any;

  render() {
    const { children } = this.props;

    return (
      <div className="ConsumerSection">
        <div className="Consumer-contentContainer">{children}</div>
      </div>
    );
  }
}

export default Section;
